import { Modifier } from '../modifier';
import type { Damage } from '../damage.type';
import { healDamage } from '../player.type';
import { actionHistory } from '../../../store';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Regeneration extends Modifier {
  static readonly baseTitle = 'Regeneration';
  static readonly baseText = 'Heal equal to the number of stacks at the start of turn, then halve.';
  static readonly baseIcon = 'regeneration';
  static readonly baseTags = [ModifierTags.Boon];
  static readonly basePriority = ModifierPriority.First;

  // Instance properties that can change
  title = Regeneration.baseTitle;
  text = Regeneration.baseText;
  icon = Regeneration.baseIcon;
  tags: Array<ModifierTags> = [...Regeneration.baseTags];
  priority = Regeneration.basePriority;

  startTurn() {
    const healing: Damage = {
      value: this.stacks,
      target: this.owner,
      source: this.owner,
      dice: [],
    };

    healDamage(healing);

    this.halveStacks();
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Regen, Regeneration);
